// Messages for portal/Settings — the company-wide settings landing card grid
// (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.settings.head': 'Settings — Portal',
  'portal.settings.title': 'Settings',
  'portal.settings.desc': 'Company-wide settings for your account',
  'portal.settings.card.team.title': 'Team',
  'portal.settings.card.team.desc': 'Invite teammates & manage roles',
  'portal.settings.card.developers.title': 'Developers',
  'portal.settings.card.developers.desc': 'API keys & rate limits for your data',
  'portal.settings.card.webhooks.title': 'Webhooks',
  'portal.settings.card.webhooks.desc': 'Subscribe your systems to events',
  'portal.settings.card.channels.title': 'Notification channels',
  'portal.settings.card.channels.desc': 'Teams / Slack / webhook destinations',
}

export const zhTW = {
  'portal.settings.head': '設定 — 客戶入口',
  'portal.settings.title': '設定',
  'portal.settings.desc': '您帳戶的公司層級設定',
  'portal.settings.card.team.title': '團隊',
  'portal.settings.card.team.desc': '邀請成員並管理角色',
  'portal.settings.card.developers.title': '開發者',
  'portal.settings.card.developers.desc': '存取您資料的 API 金鑰與速率限制',
  'portal.settings.card.webhooks.title': 'Webhook',
  'portal.settings.card.webhooks.desc': '讓您的系統訂閱事件',
  'portal.settings.card.channels.title': '通知管道',
  'portal.settings.card.channels.desc': 'Teams / Slack / Webhook 目的地',
}
